module.exports = __webpack_public_path__ + "img/slika10.f0232204.jpg";